<template>
  <el-dialog
    :title="form.id > 0 ? '编辑钻井' : '添加钻井'"
    :visible.sync="visible"
    label-width="100px"
    width="500px"
    @close="$emit('update:show', false)"
    @open="handleOpen"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="所属基地" prop="base_id">
        <BaseSelect v-model="form.base_id" :filterBlank="true"></BaseSelect>
      </el-form-item>
      <el-form-item label="井号" prop="well_number">
        <el-input v-model="form.well_number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="井队" prop="well_team">
        <el-input v-model="form.well_team" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="区块" prop="well_block">
        <el-input v-model="form.well_block" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="服务人员" prop="service_staffs">
        <StuffSelect
          v-model="form.service_staffs"
          :baseid="form.base_id"
        ></StuffSelect>
      </el-form-item>
      <el-form-item label="开始服务日期" prop="start_serve_date">
        <el-date-picker
          style="width: 100%"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="form.start_serve_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="完工日期">
        <el-date-picker
          style="width: 100%"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="form.end_serve_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="施工类型" prop="construction">
        <el-input v-model="form.construction"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { drillWellNew, drillWellUpdate } from '@/service/getData'
import BaseSelect from '@/components/select/base_select'
import StuffSelect from './stuff_select.vue'

export default {
  components: {
    BaseSelect,
    StuffSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      formData: {
        well_number: '',
        well_team: '',
        well_block: '',
        base_id: '',
        service_staffs: [],
        remark: '',
        construction: '',
        start_serve_date: '',
        end_serve_date: '',
      },
      form: {},
      visible: this.show,
      rules: {
        well_number: [
          { required: true, message: '请填写井号', trigger: 'blur' },
        ],
        base_id: [{ required: true, message: '请选择基地', trigger: 'change' }],
      },
    }
  },
  created() {
    this.form = this.formData
  },
  methods: {
    handleOpen() {
      if (this.model && this.model.id) {
        this.form = this.model
      } else {
        this.form = this.formData
      }
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form.id > 0) {
            let res = await drillWellUpdate(this.form)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await drillWellNew(this.form)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>